<template>
  <div class="titulo">
    <h1>Disculpe. Página no encontrada :(</h1>
  </div>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

<style scoped>
*{
    margin: 0;
    padding: 0;
}
.titulo{
top: 50%;
left: 50%;
position: absolute;
transform: translate(-50%,-50%);
}
</style>


// WEBPACK FOOTER //
// src/components/pages/template/NotFound.vue